
import Utils from "./Utils";
const TencentCaptcha = {
    load: function (callback) {
        if (window.TencentCaptcha) {
            callback && callback();
            return;
        }
        Utils.loadScript("https://turing.captcha.qcloud.com/TJCaptcha.js", function () {
            callback && callback();
        });
    },
    show: function (appId, { onSuccess, onError, onClose }) {
        if (!window.TencentCaptcha) {
            throw new Error("未加载");
        }
        const captcha = new window.TencentCaptcha(
            appId,
            function (res) {
                if (res.ret === 0) {
                    onSuccess && onSuccess(res.ticket, res.randstr, res);
                } else if (res.ret === 2) {
                    onClose && onClose(res);
                } else {
                    onError && onError(res);
                }
            }
        );
        captcha.show();
        return captcha;
    }
};
export default TencentCaptcha;